
import { SelecaoEditavel } from '@/dominio/editor/questoes/questao-selecao/selecao/SelecaoEditavel';
import { defineComponent } from 'vue';
import BotoesEdicao from '../../../comum/BotoesEdicao.vue';

export default defineComponent({
    name: 'SelecaoVisualizacao',
    components: { BotoesEdicao },
    props: {
        selecao: { type: SelecaoEditavel, required: true },
        ehPrimeiro: { type: Boolean, required: true },
        ehUltimo: { type: Boolean, required: true },
    },
    methods: {
        editar() {
            this.$emit('editar', this.selecao);
        },
        excluir() {
            this.$emit('excluir', this.selecao);
        },
        descer() {
            this.$emit('descer', this.selecao);
        },
        subir() {
            this.$emit('subir', this.selecao);
        },
    },
    emits: ['excluir', 'descer', 'subir', 'editar'],
});
